import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Collapse } from 'antd';
import styled from 'styled-components';

export const StyledCollapse = styled(Collapse)`
  width: 100%;
  background: transparent;
  padding-inline: 0px;
  border: none;

  .ant-collapse-item {
    border: none;
    padding-inline: 0px;
  }

  .ant-collapse-expand-icon {
    display: none; /* hide default arrow */
  }

  .ant-collapse-content {
    border: none;
    background: #fff;
    margin-top: 12px;
    padding: 0;
  }
`;

export const Panel = styled(Collapse.Panel)`
  background: transparent;
  border: none;

  .ant-collapse-header {
    background: transparent;
    color: #fff !important;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding-inline: 0px !important;
  }

  .ant-collapse-content-box {
    padding: 12px 0 !important;
    height: 70vh;
    overflow-y: auto;

    @media (max-width: 1025px) {
      height: unset;
      overflow: unset;
    }
  }
`;

export const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 10px 0;
    font-size: 15px;
    // border-bottom: 1px solid #eee;
    border-bottom: none;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const SubMenuWrapper = styled.div`
  padding-inline-start: 32px;
  padding-inline-end: 32px;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    font-size: 15px;
    border-radius: 0px;
    cursor: pointer;

    a {
      width: fit-content;
    }
  }

  li.sub-menu-item {
    border-bottom: 1px solid #cbcbcb;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }

  li.sub-menu-item:last-child {
    border-bottom: none;
  }
`;

export const BlueButton = styled.button`
  background-color: #1a295a;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  height: 40px;
  min-width: 150px;
  margin-block: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline-start: 0px;
  gap: 6px;

  &.rounded {
    border-radius: 20px;
    padding-inline: 13px 16px;
    min-width: 170px;
  }

  @media (max-width: 1250px) {
    min-width: 120px;
    font-size: 16px;

    &.rounded {
      min-width: 140px;
    }
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MenuItem = styled.li<{ $hovered: boolean }>`
  padding: 9px 15px !important;
  font-size: 16px;
  border-radius: 24px;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;

  &.sub-menu-item {
    padding: 5px 15px 4px !important;
    font-size: 15px;
    border-radius: 0px;
  }

  ${({ $hovered }) =>
    $hovered
      ? `
    background: #EAECEE;
    font-weight: ${FONT_WEIGHT.regular};
    color: #1a295a;

  `
      : `
    background: transparent;
    font-weight: ${FONT_WEIGHT.light};
    color: #1a295a;
  `}

  &.bold, &.bold a {
    font-weight: ${FONT_WEIGHT.regular};
    color: ${({ $hovered }) => ($hovered ? '#CE6239' : '#CE6239')};
  }

  &.eye {
    a {
      color: ${({ $hovered }) => ($hovered ? '#D0D4DA' : '#D0D4DA')};
      text-decoration: line-through;
    }

    &.bold,
    &.bold a {
      color: ${({ $hovered }) => ($hovered ? '#CE6239' : '#CE6239')};
      opacity: 0.5;
    }
  }

  .orange {
    color: #ce6239;
  }
`;

export const Link = styled.a`
  color: inherit;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    color: inherit;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  flex: 1 1 auto;
  width: 100%;
`;

export const Description = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  font-weight: ${FONT_WEIGHT.light};
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-top: 2px;
`;

export const HoveredIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-inline-end: 7px;
  color: #1a295a;

  img {
    width: 18px;
  }
`;
